<template>
  <section id="featured" class="featured section">

    <!-- Section Title -->
    <div class="container section-title" data-aos="fade-up">
      <h2>Nos Marchés</h2>
      <p>Nos Marchés</p>
    </div><!-- End Section Title -->

    <div class="container">

      <div class="row gy-4" data-aos="fade-up" data-aos-delay="100">

        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mganhi.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché de Ganhi</h5>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mminnontin.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché de Minnontin</h5>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mcadjehoun.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché de Cadjèhoun</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="row gy-4" data-aos="fade-up" data-aos-delay="100">
              <div id="marketCarousel" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="img" style="padding:0px !important;">
                      <img src="../land/assets/img/mgbegamey.jpg" alt="" class="img-fluid">
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="img" style="padding:0px !important;">
                      <img src="../land/assets/img/mgbegamey.jpg" alt="" class="img-fluid">
                    </div>
                  </div>
                  <!-- Add more carousel items for other markets as needed -->
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#marketCarousel"
                  data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Retour</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#marketCarousel"
                  data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Suivant</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché de Gbégamey</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mtokplegbe.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché de Tokplegbé</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/maidjedo.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Aïdjedo</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/msaintetrinite.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Sainte Trinité</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mmidombo.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Midombo</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mpk3.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché PK3</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mpahou.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Pahou</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mglazoue.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Glazoué</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="img" style="padding:0px !important;">
              <img src="../land/assets/img/mhouegbo.jpg" alt="" class="img-fluid">
            </div>
            <div class="card-body">
              <h5 class="card-title">Marché Houègbo</h5>
            </div>
          </div>
        </div>

      </div>

    </div>

  </section>
</template>
<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "SectionTrois",
  components: {},
  setup() {
    //
  }
});
</script>